import { cn } from '@/lib/utils';
import { Image, type ImageProps } from 'expo-image';
import { View, type ViewProps } from 'react-native';

type AvatarProps = ViewProps & {
  alt?: string;
  className?: string;
};

type AvatarImageProps = ImageProps & {
  className?: string;
};

type AvatarFallbackProps = ViewProps & {
  className?: string;
};

function Avatar({ alt, className, ...props }: AvatarProps) {
  return (
    <View
      accessibilityLabel={alt}
      className={cn('relative flex size-8 shrink-0 overflow-hidden rounded-full', className)}
      {...props}
    />
  );
}

function AvatarImage({ className, ...props }: AvatarImageProps) {
  return <Image className={cn('aspect-square size-full', className)} cachePolicy="memory-disk" {...props} />;
}

function AvatarFallback({ className, ...props }: AvatarFallbackProps) {
  return (
    <View
      className={cn(
        'flex size-full flex-row items-center justify-center rounded-full bg-muted',
        className
      )}
      {...props}
    />
  );
}

export { Avatar, AvatarFallback, AvatarImage };
